import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import 'styles/index.scss';
import { Route, Routes } from 'react-router-dom';
import { OidcProvider } from '@axa-fr/react-oidc';
import Layout from 'components/Layout/Layout';
import NotFound from 'containers/NotFound/NotFound';
import Loading from 'components/Oidc/Loading';
import ServiceWorkerNotSupported from 'components/Oidc/ServiceWorkerNotSupported';
import AuthenticationSuccessCallBack from 'components/Oidc/AuthenticationSuccessCallBack';
import SessionLost from 'components/Oidc/SessionLost';
import Authenticating from 'components/Oidc/Authenticating';
import AuthenticatingError from 'components/Oidc/AuthenticatingError';
import Partners from 'containers/Partners/Partners';
import Templates from 'containers/Templates/Templates';
import Home from 'containers/Home/Home';
import Tiers from 'containers/Tiers/Tiers';
import EditTier from 'containers/Tiers/EditTier';
import AddTier from 'containers/Tiers/AddTier';
import AddPartner from 'containers/Partners/AddPartner';
import EditPartner from 'containers/Partners/EditPartner';
import PartnerProfile from 'containers/Partners/PartnerProfile/PartnerProfile';
import Competencies from 'containers/Competencies/Competencies';
import AddCompetency from 'containers/Competencies/AddCompetency';
import EditCompetency from 'containers/Competencies/EditCompetency';

const { oidcAuthority, oidcClientId, oidcClientSecret, oidcRedirectUri } =
  window.config;

const configuration = {
  authority: oidcAuthority,
  redirect_uri: oidcRedirectUri,
  client_id: oidcClientId,
  scope: 'openid profile email',
  client_secret: oidcClientSecret,
  response_type: 'code',
  service_worker_relative_url: '/OidcServiceWorker.js',
  service_worker_only: false,
  token_request_extras: {
    client_secret: oidcClientSecret,
  },
};

const queryClient = new QueryClient();
export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <OidcProvider
        configuration={configuration}
        loadingComponent={Loading}
        authenticatingErrorComponent={AuthenticatingError}
        sessionLostComponent={SessionLost}
        serviceWorkerNotSupportedComponent={ServiceWorkerNotSupported}
        authenticatingComponent={Authenticating}
        callbackSuccessComponent={AuthenticationSuccessCallBack}
      >
        <Layout>
          <Routes>
            <Route index element={<Home />} />
            <Route path="partners/" element={<Partners />} />
            <Route path="partners/add" element={<AddPartner />} />
            <Route path="partners/:partnerId/edit" element={<EditPartner />} />
            <Route
              path="partners/:partnerId/profile"
              element={<PartnerProfile />}
            />
            <Route path="competencies/" element={<Competencies />} />
            <Route path="competencies/add" element={<AddCompetency />} />
            <Route
              path="competencies/:specialtyId/edit/"
              element={<EditCompetency />}
            />
            <Route path="templates/" element={<Templates />} />
            <Route path="tiers" element={<Tiers />} />
            <Route path="tiers/:tierId/edit" element={<EditTier />} />
            <Route path="tiers/add" element={<AddTier />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        {process.env.NODE_ENV === 'development' && <ReactQueryDevtools />}
      </OidcProvider>
    </QueryClientProvider>
  );
}
